import { render, staticRenderFns } from "./examinationAssignmentStatus.vue?vue&type=template&id=4adae6f8"
import script from "./examinationAssignmentStatus.vue?vue&type=script&lang=js"
export * from "./examinationAssignmentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports